import React, { useEffect, useRef, useState } from "react";
import { ActivityIndicator, Dimensions, Platform, StyleSheet, TouchableOpacity, View } from "react-native";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, TextAlignTokens, TypographyTypeDLS, } from "@voltmoney/schema";
import { ModalAlignmentEnum } from "@voltmoney/types";
import { Typography } from "../../typography/Typography";
import { Icon } from "../../icon/Icon";
import { Button } from "../../button/Button";
import { Space } from "../../space/Space";
import { OtpInput } from "../OtpInput/OtpInput";
import ThemeProvider from "@voltmoney/theme";
import BottomSheet from "../BottomSheet";
import { isMobile, isMobileView } from "../../stack/utils";
import { getScreenType } from "../loanForeclosure/LoanForeclosure";
import { RegexConfig } from "../constants";
import { TextInput } from "../../textInput/TextInput";
import * as Animatable from "react-native-animatable";
const PartnerRegisterLeads = ({ height, triggerAction, cancelAction, sendOTPAction, verifyOTPAction, sendOTPLoader, showErrorCard, counter, errorMessage, showOTPModal, closeOtpModalAction, userMobileNumber, otpState, errorCode }) => {
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const [fullName, setFullName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState(null);
    const [currentState, setCurrentState] = useState(InputStateToken.DEFAULT);
    const [otpLoader, setOtpLoader] = useState(false);
    const [otpErrorState, setOTPErrorState] = useState(false);
    const [seconds, setSeconds] = useState(15);
    const [showTimer, setShowTimer] = useState(false);
    const [successText, setSuccessText] = useState(false);
    const [otpLimitExceeded, setOtpLimitExceeded] = useState(false);
    const [isRunning, setIsRunning] = useState(false);
    const [showFailureCard, setShowFailureCard] = useState(false);
    const [showOtpModal, setShowOTPModal] = useState(false);
    const inputRef = useRef(null);
    const [otpSuccessState, setOtpSuccessState] = useState(false);
    const [isEdited, setIsEdited] = useState(false);
    const userFullNameRegex = /^[^\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{FE00}-\u{FE0F}\u{1F1E6}-\u{1F1FF}]+$/u;
    const isFromMobile = isMobileView();
    useEffect(() => {
        if (otpState === 'SUCCESS')
            setOtpSuccessState(true);
        else if (otpState === 'ERROR')
            setOTPErrorState(true);
        else if (otpState === 'DISABLED')
            setOtpLimitExceeded(true);
        else {
            setOTPErrorState(false);
            setOtpLimitExceeded(false);
        }
    }, [otpState, counter]);
    useEffect(() => {
        if (showErrorCard) {
            setShowFailureCard(showErrorCard);
        }
        else {
            setShowFailureCard(false);
        }
    }, [showErrorCard, counter]);
    useEffect(() => {
        if (showOTPModal) {
            setIsRunning(true);
            setShowOTPModal(showOTPModal);
        }
        else {
            setShowOTPModal(false);
        }
    }, [showOTPModal, counter]);
    const renderUserCancelledContent = () => {
        return (React.createElement(View, { style: styles.modal },
            React.createElement(BottomSheet, { id: "bt_borrowerKyc_cancel", autoAdjustHeight: false, height: isFromMobile ? 250 : 228, width: '100%', closeFunction: () => {
                    setShowFailureCard(false);
                    triggerAction({
                        ...closeOtpModalAction
                    });
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').height + 10 : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true },
                React.createElement(View, { style: styles.userCancelledCard },
                    React.createElement(Icon, { name: IconTokens.ErrorIcon, size: IconSizeTokens.SIZE_164 }),
                    React.createElement(View, { style: styles.title },
                        React.createElement(Typography, { label: errorCode === "BORROWER_EXISTS" ? "Failed to register customer" : "Verification failed!", fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 })),
                    React.createElement(View, { style: styles.subTitle },
                        React.createElement(Typography, { textAlign: TextAlignTokens.center, label: `${errorMessage}`, fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 4 })),
                    React.createElement(View, { nativeID: "bt_borrowerKyc_error", style: styles.errorButton },
                        React.createElement(View, null,
                            React.createElement(Button, { type: errorCode === "BORROWER_EXISTS" ? ButtonTypeTokens.LargeFilled : ButtonTypeTokens.LargeSoftFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: errorCode === "BORROWER_EXISTS" ? "Edit details" : "Try again!", width: ButtonWidthTypeToken.FULL, onPress: () => {
                                    setShowFailureCard(false);
                                    triggerAction({
                                        ...closeOtpModalAction
                                    });
                                } })))))));
    };
    useEffect(() => {
        let timer;
        if (isRunning && seconds > 0) {
            timer = setInterval(() => {
                setSeconds((prevSeconds) => prevSeconds - 1);
            }, 1000);
        }
        else if (seconds === 0) {
            setIsRunning(false);
        }
        return () => clearInterval(timer);
    }, [isRunning, seconds]);
    useEffect(() => {
        if (successText) {
            setTimeout(() => {
                setSuccessText(false);
            }, 3000);
        }
    }, [showTimer, seconds]);
    const handleTextChange = async (text) => {
        if (text.length === 6 && text[text.length - 1] >= '0' && text[text.length - 1] <= '9') {
            if (verifyOTPAction && triggerAction && !otpLimitExceeded) {
                setOtpLoader(true);
                setOTPErrorState(false);
                await triggerAction({
                    ...verifyOTPAction,
                    payload: {
                        ...verifyOTPAction.payload,
                        name: fullName,
                        otp: text,
                        phoneNumber: phoneNumber,
                        isPrevRouteLeads: true
                    },
                });
                setOtpLoader(false);
            }
        }
        else {
            setOTPErrorState(false);
        }
    };
    const handleReset = () => {
        setSeconds(15);
        setOtpLoader(false);
        setOTPErrorState(false);
        setIsRunning(true);
        setOtpSuccessState(true);
    };
    const returnOtpModal = () => {
        return (React.createElement(View, { style: {
                position: 'absolute',
                bottom: 0,
                zIndex: 99,
            } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: Platform.OS !== "web" ? 350 : 330, width: '100%', closeFunction: () => {
                    setIsRunning(false);
                    setShowOTPModal(false);
                    setOtpLoader(false);
                    setShowTimer(false);
                    setSeconds(15);
                    triggerAction({
                        ...closeOtpModalAction
                    });
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Dimensions.get('window').width
                    : 504, routeId: 'routeId', handleKeyboard: true },
                React.createElement(TouchableOpacity, { style: { padding: 16, zIndex: 1 }, activeOpacity: 1 },
                    React.createElement(Typography, { label: 'Enter 6-digit OTP', fontWeight: '600', fontSize: FontSizeTokens.MD, color: ColorTokens.Grey_Night, lineHeight: 28, fontFamily: FontFamilyTokens.Poppins }),
                    React.createElement(Space, { size: SizeTypeTokens.XL }),
                    React.createElement(View, { style: {
                            padding: 12,
                            display: 'flex',
                            borderRadius: 12,
                            borderWidth: 1,
                            borderColor: colorMapping[ColorTokens.Secondary_20],
                            backgroundColor: colorMapping[ColorTokens.Secondary_02],
                            flexDirection: 'row'
                        } },
                        React.createElement(View, { style: {
                                display: 'flex',
                                width: 40,
                                padding: 8,
                                justifyContent: 'center',
                                alignItems: 'center',
                                borderRadius: 400,
                                backgroundColor: '#FFF'
                            } },
                            React.createElement(Icon, { name: IconTokens.MessageOtp, color: ColorTokens.Secondary_100 })),
                        React.createElement(Space, { size: SizeTypeTokens.LG }),
                        React.createElement(View, { style: {
                                display: 'flex',
                                flexDirection: 'column'
                            } },
                            React.createElement(Typography, { label: 'OTP sent to', fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Charcoal, lineHeight: 18, fontFamily: FontFamilyTokens.Inter }),
                            React.createElement(Space, { size: SizeTypeTokens.XS }),
                            React.createElement(Typography, { label: `+91-${phoneNumber}`, fontWeight: '500', fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Night, lineHeight: 20, fontFamily: FontFamilyTokens.Inter }))),
                    React.createElement(Space, { size: SizeTypeTokens.XL }),
                    React.createElement(View, { style: { marginTop: 16 } },
                        React.createElement(OtpInput, { id: 'tf_loanForeclosure_otp', numberOfDigits: 6, onTextChange: handleTextChange, ref: inputRef, editable: !otpLoader, focusColor: otpErrorState ? 'red' : 'blue', theme: {
                                inputsContainerStyle: {
                                    width: 47,
                                    height: 47,
                                    borderRadius: 0,
                                },
                                pinCodeContainerStyle: { borderRadius: 8 },
                                pinCodeTextStyle: { fontSize: 15 },
                                containerStyle: { width: 300 },
                            } }),
                        React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                        React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                        React.createElement(View, { style: { marginTop: 6 } }),
                        otpLoader && !otpErrorState &&
                            React.createElement(View, { style: { flexDirection: 'row' } },
                                React.createElement(ActivityIndicator, { color: "#1434CB", size: "small" }),
                                React.createElement(View, { style: { marginLeft: 6 } },
                                    React.createElement(Typography, { label: "Verifying OTP", fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Primary_100, lineHeight: 20, fontFamily: FontFamilyTokens.Inter }))),
                        otpErrorState && inputRef?.current?.clear(),
                        React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                        React.createElement(Space, { size: SizeTypeTokens.Size6 }),
                        (otpErrorState || otpLimitExceeded) && (React.createElement(View, { style: {} },
                            React.createElement(Animatable.View, { animation: 'fadeIn', delay: 100, duration: 1000 },
                                React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: ColorTokens.System_Error, label: errorMessage ? errorMessage : "" })))),
                        React.createElement(View, { style: {
                                paddingTop: 16,
                                flexDirection: 'row',
                            } },
                            React.createElement(View, null,
                                React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: ColorTokens.Grey_Charcoal, label: "Didn't receive OTP?" })),
                            React.createElement(TouchableOpacity, { disabled: otpLimitExceeded, style: { marginLeft: 8 }, onPress: () => {
                                    if ((seconds === 0 && !otpLimitExceeded)) {
                                        setSuccessText(true);
                                        setShowTimer(false);
                                        handleReset();
                                        //@ts-ignore
                                        inputRef?.current?.clear();
                                        handleTextChange('');
                                        if (sendOTPAction) {
                                            triggerAction({
                                                ...sendOTPAction,
                                                payload: {
                                                    phoneNumber: phoneNumber,
                                                    resendOTP: true
                                                }
                                            });
                                        }
                                    }
                                    else
                                        setShowTimer(true);
                                } },
                                React.createElement(Typography, { id: 'txt_commonScreen_resendOtp', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '600', lineHeight: 20, color: (seconds === 0 && !otpLimitExceeded)
                                        ? ColorTokens.Primary_100
                                        : ColorTokens.Grey_Charcoal, label: 'Resend OTP' }))),
                        !successText && showTimer && seconds > 0 && !otpLimitExceeded && (React.createElement(View, { style: { marginTop: 10 } },
                            React.createElement(Typography, { label: `Please wait for ${seconds}s to resend OTP`, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, lineHeight: 20, color: ColorTokens.Grey_Night }))),
                        successText && !showTimer &&
                            React.createElement(View, { style: { marginTop: 10 } },
                                React.createElement(Animatable.View, { animation: 'fadeIn', delay: 100, duration: 1000 },
                                    React.createElement(Typography, { label: `OTP sent successfully`, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, lineHeight: 20, color: ColorTokens.Secondary_100 }))))))));
    };
    const bodyPart = () => {
        return (React.createElement(View, { style: { height: height - 4 } },
            React.createElement(View, { style: {
                    height: 56,
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    padding: 16,
                    alignItems: 'center',
                    alignContent: 'center'
                } },
                React.createElement(Typography, { label: "Register customer", typeDLS: TypographyTypeDLS.H3B, color: ColorTokens.Grey_Night }),
                React.createElement(TouchableOpacity, { onPress: () => {
                        triggerAction({
                            ...cancelAction
                        });
                    }, hitSlop: { top: 24, bottom: 24, left: 24, right: 24 } },
                    React.createElement(Icon, { name: IconTokens.Cross, size: IconSizeTokens.XXXXL, color: ColorTokens.Grey_Charcoal }))),
            React.createElement(View, { style: {
                    width: '100%',
                    height: 1,
                    backgroundColor: '#E4E7EC',
                } }),
            React.createElement(View, { style: { paddingHorizontal: 16, paddingBottom: 16, paddingTop: 24 } },
                React.createElement(Typography, { label: "Enter customer details", typeDLS: TypographyTypeDLS.H3S, color: ColorTokens.Grey_Charcoal }),
                React.createElement(View, { style: { marginTop: 20, marginBottom: 16 } },
                    React.createElement(TextInput, { showErrorAnimation: true, showErrorOnFocus: true, isFocus: true, value: fullName, type: InputTypeToken.DEFAULT, title: "Full name*", id: 'tf_registerLeads_fullName', keyboardType: KeyboardTypeToken.default, placeholder: "Enter full name", onChangeText: async (text) => {
                            setFullName(text.trim());
                        }, state: fullName.length > 0 ? userFullNameRegex.test(fullName) ? InputStateToken.SUCCESS : InputStateToken.ERROR : InputStateToken.DEFAULT, caption: { error: "Please enter a valid name" }, showSuccessWithoutRegex: true })),
                React.createElement(View, null,
                    React.createElement(TextInput, { onlyNumeric: true, showErrorAnimation: true, extraSpace: 15, showErrorOnFocus: false, isFocus: false, value: isEdited ? phoneNumber : userMobileNumber, regex: RegexConfig.MOBILE, type: InputTypeToken.MOBILE, state: currentState, title: "Mobile number*", charLimit: 10, keyboardType: KeyboardTypeToken.numberPad, placeholder: "Enter mobile number", id: 'tf_registerLeads_mobileNumber', onChangeText: async (text) => {
                            setIsEdited(true);
                            setPhoneNumber(text.trim());
                            setCurrentState(InputStateToken.DEFAULT);
                        } }))),
            React.createElement(View, { style: { position: 'absolute', bottom: 0, width: '100%' } }, footerChild())));
    };
    const footerChild = () => {
        return (React.createElement(View, { style: { height: 88, width: '100%' } },
            React.createElement(View, { style: {
                    width: '100%',
                    height: 1,
                    backgroundColor: '#E4E7EC',
                } }),
            React.createElement(View, { style: { paddingHorizontal: 16, paddingBottom: 16, paddingTop: 12 } },
                React.createElement(View, { style: { alignItems: 'center', alignContent: 'center', marginBottom: 4 } },
                    React.createElement(Typography, { label: "OTP will be sent to mobile for verification", typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal })),
                React.createElement(Button, { type: fullName && userFullNameRegex.test(fullName) && phoneNumber && phoneNumber?.length === 10 ? ButtonTypeTokens.LargeFilled : ButtonTypeTokens.LargeOutline, label: "Send OTP", width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM, loading: sendOTPLoader, onPress: () => {
                        triggerAction({
                            ...sendOTPAction,
                            payload: {
                                phoneNumber: phoneNumber,
                                name: fullName
                            }
                        });
                    } }))));
    };
    return (React.createElement(View, { style: { height: height } },
        bodyPart(),
        showOtpModal && !showErrorCard && returnOtpModal(),
        showFailureCard && renderUserCancelledContent()));
};
const styles = StyleSheet.create({
    userCancelledCard: {
        alignItems: "center",
        flex: 1,
        height: 260,
        padding: 16,
        justifyContent: 'space-between',
    },
    title: {
        marginTop: 16,
    },
    subTitle: {
        marginTop: 8,
        padding: 8,
        marginBottom: 8,
    },
    errorButton: {
        width: '90%',
        marginTop: 16,
        paddingHorizontal: 16,
        paddingBottom: 8,
        marginBottom: 4
    },
    modal: {
        bottom: 0,
        position: 'absolute',
        zIndex: 1,
    },
});
// @ts-ignore
export default (PartnerRegisterLeads);
